<template>
   <el-form-item class="widget-view "
      v-if="element && element.key" 
      :class="{active: selectWidget.key == element.key, 'is_req': element.options.filter(x => x.attrName == 'regex').length>0?element.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'required')[0].value : false}"
      :label="element.options.filter(x => x.attrName == 'formTitle')[0]?element.options.filter(x => x.attrName == 'formTitle')[0].value:''"
      @click.native.stop="handleSelectWidget(index)"
    > 
        <template v-if="element.type == 'input'">
          <el-input 
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
            :disabled="element.options.filter(x => x.attrName == 'disabled')[0].value"
            :placeholder="element.options.filter(x => x.attrName == 'placeholder')[0].value"
          ></el-input>
        </template>
        
        <template v-if="element.type == 'textarea'">
          <el-input type="textarea" :rows="5"
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
            :disabled="element.options.filter(x => x.attrName == 'disabled')[0].value"
            :placeholder="element.options.filter(x => x.attrName == 'placeholder')[0].value"
          ></el-input>
        </template>

        <template v-if="element.type == 'number'">
          <el-input-number 
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value" 
            :disabled="element.options.filter(x => x.attrName == 'disabled')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
          ></el-input-number>
        </template>

        <template v-if="element.type == 'radio'">
          <el-radio-group v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
            :disabled="element.options.filter(x => x.attrName == 'disabled')[0].value"
          >
            <el-radio  
              :style="{display: element.options.filter(x => x.attrName == 'inline')[0].value == 'true' ? 'inline-block' : 'block'}"
              :label="item.value" v-for="(item, index) in element.options.filter(x => x.attrName == 'dynamicChange')[0].list[0].options" :key="item.value + index"
              
            >
              {{element.options.filter(x => x.attrName == 'showLabel')[0].value ? item.label : item.value}}
            </el-radio>
          </el-radio-group>
        </template>

        <template v-if="element.type == 'checkbox'">
        	<el-checkbox-group v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
            :disabled="element.options.filter(x => x.attrName == 'disabled')[0].value"
          >
            <el-checkbox  
              :style="{display: element.options.filter(x => x.attrName == 'inline')[0].value == 'true' ? 'inline-block' : 'block'}"
              :label="item.value" v-for="(item, index) in element.options.filter(x => x.attrName == 'dynamicChange')[0].list[0].options" :key="item.value + index"
              
            >
              {{element.options.filter(x => x.attrName == 'showLabel')[0].value ? item.label : item.value}}
            </el-checkbox>
         </el-checkbox-group>
        </template>

        <template v-if="element.type == 'time'">
          <el-time-picker 
            v-model="element.options.filter(x => x.attrName == 'defaultTimeValue')[0].value"
            :is-range="element.options.filter(x => x.attrName == 'isRange')[0].value"
            :placeholder="element.options.filter(x => x.attrName == 'placeholder')[0].value"
            :start-placeholder="element.options.filter(x => x.attrName == 'startPlaceholder')[0].value"
            :end-placeholder="element.options.filter(x => x.attrName == 'endPlaceholder')[0].value"
            :readonly="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'readonly')[0].value"
            :disabled="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'disabled')[0].value"
            :editable="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'editable')[0].value"
            :clearable="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'clearable')[0].value"
            :arrowControl="element.options.filter(x => x.list && x.list.length > 0 && x.attrName == 'attr')[0].list.filter(el => el.attrName == 'arrowControl')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
          >
          </el-time-picker>
        </template>

        <template v-if="element.type == 'date'">
          <el-date-picker
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :type="element.options.filter(x => x.attrName == 'type')[0].value"
            :placeholder="element.options.filter(x => x.attrName == 'placeholder')[0].value"
            :readonly="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'readonly')[0].value"
            :disabled="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'disabled')[0].value"
            :editable="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'editable')[0].value"
            :clearable="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'clearable')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"  
          >
          </el-date-picker>
        </template>

        <template v-if="element.type == 'rate'">
          <el-rate v-model="element.options.filter(x => x.attrName == 'defaultRateValue')[0].value"
            :max="element.options.filter(x => x.attrName == 'max')[0].value"
            :disabled="element.options.filter(x => x.attrName == 'disabled')[0].value"
            :allow-half="element.options.filter(x => x.attrName == 'allowHalf')[0].value"
          ></el-rate>
        </template>

        <template v-if="element.type == 'color'">
          <el-color-picker 
            v-model="element.options.filter(x => x.attrName == 'defaultColorValue')[0].value"
            :disabled="element.options.filter(x => x.attrName == 'disabled')[0].value"
            :show-alpha="element.options.filter(x => x.attrName == 'showAlpha')[0].value"
          ></el-color-picker>
        </template>

        <template v-if="element.type == 'select'">
          <el-select
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :disabled="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'disabled')[0].value"
            :multiple="element.options.filter(x => x.attrName == 'multiple')[0].value"
            :clearable="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'clearable')[0].value"
            :placeholder="element.options.filter(x => x.attrName == 'placeholder')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
          >
            <el-option v-for="item in element.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(el => el.attrName == 'remote')[0].options" :key="item.value" :value="item.value" :label="element.options.filter(x => x.attrName == 'showLabel')[0].value?item.label:item.value"></el-option>
          </el-select>
        </template>

        <template v-if="element.type=='switch'">
          <el-switch
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :active-value="element.options.filter(x => x.attrName == 'activeValue')[0].value"
            :inactive-value="element.options.filter(x => x.attrName == 'InActiveValue')[0].value"
            :disabled="element.options.filter(x => x.attrName == 'disabled')[0].value"
          >
          </el-switch>
        </template>

        <template v-if="element.type=='slider'">
          <el-slider 
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :min="element.options.filter(x => x.attrName == 'min')[0].value"
            :max="element.options.filter(x => x.attrName == 'max')[0].value"
            :disabled="element.options.filter(x => x.attrName == 'disabled')[0].value"
            :step="element.options.filter(x => x.attrName == 'step')[0].value"
            :show-input="element.options.filter(x => x.attrName == 'showInput')[0].value"
            :range="false"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
          ></el-slider>
        </template>

        <template v-if="element.type=='imgupload'">
          <!-- <fm-upload
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :disabled="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'disabled')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
            :width="element.options.filter(x => x.attrName == 'width')[0].value"
            token="xxx"
            domain="xxx"
            :multiple="element.options.filter(x => x.attrName == 'multiple')[0].value"
		        :length="element.options.filter(x => x.attrName == 'length')[0].value"
		        :is-qiniu="element.options.filter(x => x.attrName == 'isQiniu')[0].value"
		        :is-delete="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'isDelete')[0].value"
		        :min="element.options.filter(x => x.attrName == 'min')[0].value"
		        :is-edit="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'isEdit')[0].value"
		        :action="element.options.filter(x => x.attrName == 'action')[0].value"
          >
            
          </fm-upload> -->
          <el-upload
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :disabled="element.options.filter(x => x.attrName == 'disabled')[0].value"
            :class="[element.options.filter(x => x.attrName == 'class')[0].value]"
            :multiple="element.options.filter(x => x.attrName == 'multiple')[0].value"
            :action="element.options.filter(x => x.attrName == 'action')[0].value"
            :accept="element.options.filter(x => x.attrName == 'accept')[0].value"
            :show-file-list="element.options.filter(x => x.attrName == 'showFile')[0].value"
          >
            <template v-if="element.options.filter(x => x.attrName == 'listtype')[0].value == 'picture'">
              <el-button size="small" type="primary">点击上传</el-button>
            </template>
            <template v-else-if="element.options.filter(x => x.attrName == 'listtype')[0].value == 'picture-card'">
              <i class="el-icon-plus"></i>
            </template>
            <template v-else>
              <img v-if="element.options.filter(x => x.attrName == 'defaultValue')[0].value" :src="element.options.filter(x => x.attrName == 'defaultValue')[0].value" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </template>  
          </el-upload>
        </template>

				<template v-if="element.type == 'upload'">
          <el-upload
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :disabled="element.options.filter(x => x.attrName == 'disabled')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
            :multiple="element.options.filter(x => x.attrName == 'multiple')[0].value"
            :action="element.options.filter(x => x.attrName == 'action')[0].value"
            :accept="element.options.filter(x => x.attrName == 'accept')[0].value"
            :show-file-list="element.options.filter(x => x.attrName == 'showFile')[0].value"
          >
           <el-button size="small" type="primary">点击上传</el-button> 
          </el-upload>
        </template>

        <template v-if="element.type == 'cascader'">
          <el-cascader
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :disabled="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'disabled')[0].value"
            :clearable="element.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'clearable')[0].value"
            :placeholder="element.options.filter(x => x.attrName == 'placeholder')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
            :options="element.options.filter(x => x.attrName == 'remoteOptions')[0].value"
          >
          </el-cascader>
        </template>

        <template v-if="element.type == 'editor'">
          <vue-editor
            v-model="element.options.filter(x => x.attrName == 'defaultValue')[0].value"
            :style="{width:element.options.filter(x => x.attrName == 'width')[0].value}"
          >
          </vue-editor>
        </template>

        <template v-if="element.type=='blank'">
          <div style="height: 50px;color: #999;background: #eee;line-height:50px;text-align:center;">自定义区域</div>
        </template>

        <template v-if="element.type == 'text'">
          <span >{{element.options.filter(x => x.attrName == 'defaultValue')[0].value}}</span>
        </template>
				
				<template v-if="element.type == 'divider'">
          <el-divider :direction="element.options.filter(x => x.attrName == 'direction')[0].value"
                      :content-position="element.options.filter(x => x.attrName == 'position')[0].value">{{element.options.filter(x => x.attrName == 'defaultValue')[0].value}}</el-divider>
       </template>
        <div class="widget-view-action" v-if="selectWidget.key == element.key">
          <i class="el-icon-copy-document" @click.stop="handleWidgetClone(index)"></i>
          <i class="el-icon-delete" @click.stop="handleWidgetDelete(index)"></i>
        </div>

        <div class="widget-view-drag" v-if="selectWidget.key == element.key">
          <i class="el-icon-rank drag-widget"></i>
        </div> 
        
     </el-form-item> 
</template>

<script>
import FmUpload from './Upload'
import { VueEditor } from "vue2-editor"
export default {
  props: ['element', 'select', 'index', 'data'],
  components: {
    FmUpload,
    VueEditor
  },
  data () {
    return {
      selectWidget: this.select,
    }
  },
  methods: {
    handleSelectWidget (index) {
      this.selectWidget = this.data.list[index]
    },
    handleWidgetDelete (index) {
      if (this.data.list.length - 1 === index) {
        if (index === 0) {
          this.selectWidget = {}
        } else {
          this.selectWidget = this.data.list[index - 1]
        }
      } else {
        this.selectWidget = this.data.list[index + 1]
      }

      this.$nextTick(() => {
        this.data.list.splice(index, 1)
      })
    },
    handleWidgetClone (index) {
      let cloneData = {
        ...this.data.list[index],
        options: this.data.list[index].options ? JSON.parse(JSON.stringify(this.data.list[index].options)) : null,
        key: Date.parse(new Date()) + '_' + Math.ceil(Math.random() * 99999)
      }

      // if (this.data.list[index].type === 'radio' || this.data.list[index].type === 'checkbox') {

      //   cloneData = {
      //     ...cloneData,
      //     options: {
      //       ...cloneData.options,
      //       options: cloneData.options.options.map(item => ({...item}))
      //     }
      //   }
      // }

      this.data.list.splice(index, 0, cloneData)

      this.$nextTick(() => {
        this.selectWidget = this.data.list[index + 1]
      })
    },
    modelValue(response, file, fileList, defaultvalue){
    	console.log(response, file, fileList, defaultvalue)
    }
  },
  watch: {
    select (val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler (val) {
        this.$emit('update:select', val)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/vueformmaking/WidgetFormItem.vue